import { render, staticRenderFns } from "./adVideo.vue?vue&type=template&id=0643f708&scoped=true&"
import script from "./adVideo.vue?vue&type=script&lang=js&"
export * from "./adVideo.vue?vue&type=script&lang=js&"
import style0 from "./adVideo.vue?vue&type=style&index=0&id=0643f708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643f708",
  null
  
)

export default component.exports